import Axios from "axios";
import { AUTH_API, AUTH_AXIOS_OPTIONS } from "./../../utils/constants";
import { IUser } from "./interfaces";
import { handleAxiosError } from "../../utils/functions";

export const getMunicipios = async () => {
  try {
    const api = `${AUTH_API}/municipios`;
    const res = await Axios.get(api, AUTH_AXIOS_OPTIONS);
    return res.data.municipios;
  } catch (err) {
    const error = err as any;
    throw await handleAxiosError(error);
  }
};

export const getEstadosCiviles = async () => {
  try {
    const api = `${AUTH_API}/estados-civiles`;
    const res = await Axios.get(api, AUTH_AXIOS_OPTIONS);
    return res.data.estadosCiviles;
  } catch (err) {
    const error = err as any;
    throw await handleAxiosError(error);
  }
};

export const signin = async (user: IUser) => {
  try {
    const api = `${AUTH_API}/usuarios`;
    const res = await Axios.post(api, JSON.stringify(user), AUTH_AXIOS_OPTIONS);
    if (res.status === 200) return true;
    return false;
  } catch (err) {
    const error = err as any;
    throw await handleAxiosError(error);
  }
};
